import { useEffect, useRef, useState } from "react";
import "./ESG.css";
import { Swiper as SwiperReact, SwiperSlide } from "swiper/react";
import Dash from "../../components/Dash/Dash";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

import {
  SliderImg1,
  SliderImg2,
  SliderImg3,
  SliderImg4,
  FirstImg,
  SecondImg,
  ThirdImg,
  FourthImg,
  FifthImg,
  CSR1,
  CSR2,
  sanathanLogoEsg,
  silaLogoEsg,
  plantsEsg,
  plasticEsg,
  absorptionEsg,
  yearEsg,
  microGreenEsg,
  flexReviroEsg,
  strechYarnPLP,
  tabSlider1,
  tabSlider2,
  tabSlider3,
  tabSlider5,
  tabSlider4,
  goonjLogo,
  goonjLogo02,
  esgSanathanLogoWhite,
  clothSlide05,
  clothSlide06,
  clothSlide07,
  clothSlide08,
  clothSlide09,
  clothSlide10,
  clothSlide11,
  clothSlide12,
  clothSlide13,
  esgLeftLeaf,
  esgMiddleLeaf,
  esgRightLeaf,
  esgTotalCollected,
  esgCo2Avoided,
  esgWaterAvoided,
  esgLandfillDiversion,
  esgReuseShare,
  esgRecycledShare,
} from "../../images";

//swiper imports
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
  Parallax,
  Mousewheel,
  Controller,
} from "swiper";
import "swiper/swiper-bundle.css";
import { Link } from "react-router-dom";
import CounterItem from "../../components/CounterItem/CounterItem";
import { useLocation, useHistory } from "react-router-dom";

Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Thumbs,
  EffectFade,
  Parallax,
  Mousewheel,
  Controller,
]);

const tabs = [
  "Environmental Impact – Made Tangible",
  "Well-being & Workplace Productivity",
  "Symbolism & Sustainable Culture",
];
const tabsSliderimages = [
  tabSlider1,
  tabSlider2,
  tabSlider3,
  tabSlider4,
  tabSlider5,
];

const clothsliderimages = [
  clothSlide05,
  clothSlide06,
  clothSlide07,
  clothSlide08,
  clothSlide09,
  clothSlide10,
  clothSlide11,
  clothSlide12,
  clothSlide13,
];

const ESG = () => {
  const { width } = useWindowDimensions();
  const location = useLocation();
  const history = useHistory();

  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    var esg_second_main_section_slider_wrapper = new Swiper(
      ".swiper-container.esg_second_main_section_slider_wrapper",
      {
        // slidesPerView: 4,
        // spaceBetween: 36,
        allowTouchMove: false,
        breakpoints: {
          1023: {
            slidesPerView: 4,
            spaceBetween: 36,
          },
          768: {
            slidesPerView: 3,
            // autoplay: {
            //     delay: 2000
            // },
            // loop: true,
            // loopedSlides: 4
          },
          375: {
            slidesPerView: 1,
            // autoplay: {
            //     delay: 2000
            // },
            // loop: true,
            // loopedSlides: 4
          },
        },
        navigation: {
          nextEl: ".navigations .right_arrow",
          prevEl: ".navigations .left_arrow",
        },
      }
    );

    var cloth_slider_wrapper = new Swiper(
      ".swiper-container.cloth_slider_wrapper",
      {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        freeMode: true,
        grabCursor: false,
        allowTouchMove: false,
        slidesPerView: 3.4,
        autoplay: {
          delay: 1,
          disableOnInteraction: true,
        },
        speed: 5000,
        // navigation: {
        //   nextEl: ".cloth_slider_wrapper .right_arrow",
        //   prevEl: ".cloth_slider_wrapper .left_arrow",
        // },
        spaceBetween: 40,
        breakpoints: {
          0: {
            slidesPerView: 1.3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            spaceBetween: 30,
            slidesPerView: 3.4,
          },
          1280: {
            spaceBetween: 40,
            slidesPerView: 3.4,
          },
        },
      }
    );
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const targetId = hash.substring(1);
      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        setTimeout(() => {
          const offset = width > 767 ? 200 : 150; // Gap from viewport top
          const targetPosition =
            targetSection.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: targetPosition, behavior: "smooth" });
          // targetSection.scrollIntoView({ behavior: "smooth" });
        }, 100);
        history.replace(location.pathname);
      }
    }
  }, [location]);

  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/esg"
        metaTitle="Environmental Social Governance | Sanathan Textiles"
        metaDesc="Learn about Sanathan Textiles' ESG commitment. Our setup emphasizes environmental sustainability, social responsibility & ethical governance in the textiles industry. "
      />

      <section className="esg esg_desktop">
        <div className="wrapper" data-aos="fade-in">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} ESG
          </div>
          <div className="left_section">
            <h1 className="hollow_title ">Corporate Social Responsibility</h1>
            <div className="dash_wrapper">
              <Dash />
            </div>
            {/* <h3>Environmental / Social / Governance</h3> */}
            <p>
              We have constituted a corporate and social responsibility
              committee and have adopted and implemented a CSR Policy pursuant
              to which we carry out CSR activities. In terms of our CSR policy
              our CSR expenditure may be towards, amongst others, eradicating
              hunger, poverty and malnutrition, promoting health care, promoting
              education, promoting gender equality, empowering women, ensuring
              environmental sustainability, ecological balance etc.
            </p>
          </div>
          <figure className="bg_img">
            <img src={FirstImg} alt="sanathan img" width={726} height={813} />
          </figure>
        </div>
      </section>

      <section className="esg esg_mobile">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} ESG
          </div>
        </div>
      </section>

      <div className="esg_mobile_wrapper">
        <div className="wrapper">
          <div className="left_section">
            <div className="hollow_title mb_hollow_title">
              Corporate Social Responsibility
            </div>
            <div className="dash_wrapper mb_dash_wrapper">
              <Dash />
            </div>
            {/* <h3 className="enviro_h3">Environmental / Social / Governance</h3> */}
            <figure className="bg_img">
              <img src={FirstImg} alt="sanathan img" width={373} height={417} />
            </figure>
          </div>
          <p>
            We have constituted a corporate and social responsibility committee
            and have adopted and implemented a CSR Policy pursuant to which we
            carry out CSR activities. In terms of our CSR policy our CSR
            expenditure may be towards, amongst others, eradicating hunger,
            poverty and malnutrition, promoting health care, promoting
            education, promoting gender equality, empowering women, ensuring
            environmental sustainability, ecological balance etc.
          </p>
        </div>
      </div>

      {/* <section className="esg_sec3">
        <div className="wrapper">
          <div className="env_content_wrapper" data-aos="fade-up">
            <h2 className="mb_title">
              World Environment Day Initiative – 2026
            </h2>
            <div className="top_row">
              <div className="left_logo">
                <img
                  src={goonjLogo02}
                  alt="Goonj Logo"
                  width={59}
                  height={59}
                  className="goonj_logo"
                />
              </div>

              <h2 className="title">World Environment Day Initiative – 2026</h2>

              <div className="right_logo">
                <img
                  src={esgSanathanLogoWhite}
                  alt="sanathan Logo"
                  width={148}
                  height={100}
                  className="sanathan_logo"
                />
              </div>
            </div>

            <div className="content_wrapper">
              <p className="quote">
                "Small Acts. Big Impact. Together for a Sustainable Future."
              </p>

              <h3 className="sub_title">Giving Clothes a second life</h3>

              <p className="description">
                Sanathan Textiles Limited is pleased to undertake a Clothes
                Donation Drive in association with Goonj, an NGO working towards
                sustainable reuse and community development. The collected
                clothes will be handed over to Goonj, who will clean, segregate
                and distribute reusable clothing to rural communities engaged in
                environmental projects. with "A small act from our wardrobes can
                create a larger impact — giving clothes and textile material a
                second life while supporting dignity, circular economy, and
                rural development."
              </p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="esg_sec3--1">
        <img
          src={esgLeftLeaf}
          alt="leaf"
          width={442}
          height={442}
          className="left_leaf"
        />
        <img
          src={esgMiddleLeaf}
          alt="leaf"
          width={454}
          height={454}
          className="middle_leaf"
        />
        <img
          src={esgRightLeaf}
          alt="leaf"
          width={456}
          height={630}
          className="right_leaf"
        />
        <div className="env_content_wrapper" data-aos="fade-up">
          <div className="wrapper">
            <h2 className="mb_title">
              World Environment Day Initiative – 2026
            </h2>

            <div className="top_row">
              <div className="left_logo">
                <img
                  src={goonjLogo02}
                  alt="Goonj Logo"
                  width={59}
                  height={59}
                  className="goonj_logo"
                />
              </div>

              <h2 className="title">World Environment Day Initiative – 2026</h2>

              <div className="right_logo">
                <img
                  src={esgSanathanLogoWhite}
                  alt="sanathan Logo"
                  width={148}
                  height={100}
                  className="sanathan_logo"
                />
              </div>
            </div>

            <p className="quote">
              "Small Acts. Big Impact. Together for a Sustainable Future."
            </p>

            <div className="content_grid">
              <div className="content_col">
                <h3 className="sub_title">
                  Sanathan Textiles' Commitment to Reuse, Empowerment and
                  Responsible Manufacturing
                </h3>
                <p className="description">
                  For World Environment Day 2026, Sanathan Textiles partnered
                  with Goonj on a clothes collection drive across its Mumbai HO,
                  Silvassa and Punjab locations. Wearable items are re-shared
                  with rural communities, while the rest is recycled or turned
                  into products like bags by trained rural women. The drive
                  collected approximately 770 kgs of clothes and textile
                  materials.
                </p>
                <p className="description">
                  Sanathan Textiles partnered with BMC to engage a self-help
                  group of 30 women, earlier supported with jewellery-making
                  training, on reducing plastic usage in daily life. Reusable
                  bags were distributed to encourage this shift. The initiative
                  combined environmental awareness with women's empowerment.
                </p>
                <p className="description">
                  The Company also partnered with artist Mrs. Minali Thakkar on
                  an environment-themed artwork of a hand supporting yarns,
                  symbolising its responsibility as a yarn manufacturer. This
                  complements ongoing efforts such as Zero Liquid Discharge,
                  water recycling, rice husk fuel, solar energy and recycled-PET
                  yarns. Together, these initiatives reaffirm Sanathan Textiles'
                  commitment to reuse, community support and responsible
                  manufacturing.
                </p>
              </div>

              <div className="content_col">
                <div className="data_container">
                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgTotalCollected}
                        width={70}
                        height={70}
                        alt="Year Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">700 kg</h3>
                      <p className="data_text">Total Collected</p>
                    </div>
                  </div>

                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgLandfillDiversion}
                        width={70}
                        height={84}
                        alt="Space Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">0.77 tonnes</h3>
                      <p className="data_text">Landfill diversion</p>
                    </div>
                  </div>

                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgRecycledShare}
                        width={70}
                        height={84}
                        alt="Space Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">308 kg (40%)</h3>
                      <p className="data_text">Recycled share</p>
                    </div>
                  </div>

                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgReuseShare}
                        width={70}
                        height={84}
                        alt="Space Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">462 kg (60%)</h3>
                      <p className="data_text">Reuse share</p>
                    </div>
                  </div>

                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgWaterAvoided}
                        width={70}
                        height={70}
                        alt="Year Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">4.62M - 9.24M litres</h3>
                      <p className="data_text">
                        Est. water avoided (reuse only)
                      </p>
                    </div>
                  </div>

                  <div className="data_wrapper">
                    <div className="data_icon_wrapper">
                      <img
                        src={esgCo2Avoided}
                        width={70}
                        height={84}
                        alt="Space Icon"
                        className="data_icon"
                      />
                    </div>
                    <div className="data_text_wrapper">
                      <h3 className="data_title">~11.55 tonnes CO2e</h3>
                      <p className="data_text">Est. CO2 avoided (reuse only)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cloth_slider_wrapper swiper-container">
          <ul className="swiper-wrapper">
            {clothsliderimages.map((item, index) => (
              <li className="swiper-slide" key={index}>
                <img
                  src={item}
                  alt={`cloth ${index + 1}`}
                  width={542}
                  height={371}
                  className="cloth_slide_img"
                />
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="esg_sec4" id="plastictoplant">
        <div className="wrapper">
          <div className="head_wrapper" data-aos="fade-up">
            {width > 767 && (
              <img
                src={silaLogoEsg}
                alt="sila logo"
                width={172}
                height={68}
                className="sila_logo"
              />
            )}
            <h2 className="title">World Environment Day Initiative – 2025</h2>
            {width <= 767 && (
              <img
                src={silaLogoEsg}
                alt="sila logo"
                width={172}
                height={68}
                className="sila_logo"
              />
            )}
            <img
              src={sanathanLogoEsg}
              alt="sanathan logo"
              width={142}
              height={96}
              className="sanathan_logo"
            />
          </div>

          <div className="text_container" data-aos="fade-up">
            <h3 className="sub_title">Plastic-to-Plant Exchange Drive</h3>
            <p className="desc">
              Sanathan Textiles was proud to host a Plastic-to-Plant Exchange
              Drive at Mumbai and Silvassa in collaboration with Sila. In this
              initiative, green champions were invited to deposit at least 200
              grams of plastic in exchange for a plant, symbolising a small but
              meaningful shift towards sustainability.
            </p>
          </div>

          <div className="row env_row" data-aos="fade-up">
            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_plant">
                  <img src={plantsEsg} alt="plastic" className="env_icon" />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <CounterItem
                      startCount={0}
                      endCount={2500}
                      duration={3}
                      separator=","
                    />
                    <p className="counter_title">Total Plants Distributed</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_plastic">
                  <img src={plasticEsg} alt="plastic" className="env_icon" />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <CounterItem
                      startCount={0}
                      endCount={500}
                      duration={3}
                      unit="kg"
                    />
                    <p className="counter_title">
                      Plastic Diverted from Waste for <br />
                      recycling
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_absorp">
                  <img
                    src={absorptionEsg}
                    alt="absorption"
                    className="env_icon"
                  />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <div className="counter_wrapper">
                      <CounterItem
                        startCount={0}
                        endCount={625}
                        duration={3}
                        // unit="gms"
                      />
                      <span className="hyphen">-</span>
                      <CounterItem
                        startCount={0}
                        endCount={750}
                        duration={3}
                        unit="gms"
                      />
                    </div>
                    <p className="counter_title">
                      Daily CO₂ Absorption (Total)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_year">
                  <img src={yearEsg} alt="year" className="env_icon" />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <div className="counter_wrapper">
                      <CounterItem
                        startCount={0}
                        endCount={228}
                        duration={3}
                        // unit="gms"
                      />
                      <span className="hyphen">-</span>
                      <CounterItem
                        startCount={0}
                        endCount={274}
                        duration={3}
                        unit="kgs"
                      />
                    </div>
                    <p className="counter_title">
                      Annual CO₂ Absorption (Estimated)
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_green">
                  <img
                    src={microGreenEsg}
                    alt="green zone"
                    className="env_icon"
                  />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <CounterItem
                      startCount={0}
                      endCount={2500}
                      duration={3}
                      unit="spaces"
                      separator=","
                    />
                    <p className="counter_title">Micro Green Zones Created</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 env_col">
              <div className="env_box">
                <div className="img_wrapper img_reviro">
                  <img src={flexReviroEsg} alt="reviro" className="env_icon" />
                </div>
                <div className="content_wrapper">
                  <div className="counter_container">
                    <CounterItem
                      startCount={0}
                      endCount={350}
                      duration={3}
                      unit="kgs"
                    />
                    <p className="counter_title">
                      Flex can be generated for{" "}
                      <Link to="/products/reviro" target="_blank">
                        Sanathan Reviro
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="note_wrapper">
            <p className="note_text">
              Please note the Plastic was shared with External Party for
              recycling and Sanathan Textiles does not recycle the flex in-house
            </p>
          </div>
        </div>
      </section>
      <section className="why_it_matters_section">
        <div className="wrapper">
          <div className="why_it_matters_heading" data-aos="fade-up">
            Why it Matters?
          </div>

          <div className="tabs_section">
            <div className="tab_header_wrapper" data-aos="fade-up">
              <div className="tab_header_scroll">
                <div className="tab_header">
                  {tabs.map((tab, index) => (
                    <button
                      key={index}
                      className={`tab_btn ${
                        activeIndex === index ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(index)}
                    >
                      <span className="tab_main_span">{tab}</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="tab_row_esg row" data-aos="fade-up">
              <div className="col-lg-6 col-12">
                <div className="tab_content">
                  {activeIndex === 0 && (
                    <div
                      className="tab_panel"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    >
                      <ul class="custom-bullet-list">
                        <li>Each plant absorbs 250–300 mg of CO₂ per day.</li>
                        <li>
                          A collective of 2,500 plants can absorb approximately
                          0.75 kg of CO₂ daily, offsetting up to 274 kg
                          annually.
                        </li>
                      </ul>
                      <div className="title_tabs_content">
                        What does this mean?
                      </div>
                      <ul className="custom-bullet-list">
                        <li>
                          Equivalent to the CO₂ from 17,000 phone charges, 35
                          hours of idling, or burning 120L of petrol.
                        </li>
                        <li>
                          Diverts 500 kg of plastic waste – roughly equivalent
                          to 25,000 plastic bottles.
                        </li>
                      </ul>
                    </div>
                  )}
                  {activeIndex === 1 && (
                    <div
                      className="tab_panel"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    >
                      <ul class="custom-bullet-list">
                        <li>
                          Plants purify indoor air, reduce stress, and improve
                          focus.
                        </li>
                        <li>
                          Research shows that adding plants to workspaces can
                          boost productivity by up to 15%.
                        </li>
                      </ul>
                    </div>
                  )}
                  {activeIndex === 2 && (
                    <div
                      className="tab_panel"
                      data-aos="fade-up"
                      data-aos-duration="1000"
                    >
                      {" "}
                      <ul class="custom-bullet-list">
                        <li>
                          Each plant represents growth, mindfulness, and
                          responsibility
                        </li>
                        <li>
                          Reinforces the message that sustainability begins with
                          simple actions
                        </li>
                        <li>
                          Reinforces the message that sustainability begins with
                          simple actions
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-5 col-12 col-slider-esg">
                <SwiperReact
                  slidesPerView={1}
                  loop={true}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  className="image_slider"
                >
                  {tabsSliderimages.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={img}
                        alt={`Slide ${index + 1}`}
                        className="slider_img"
                      />
                    </SwiperSlide>
                  ))}
                </SwiperReact>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="esg_sec6 parallax_section">
        <div className="parallax_overlay">
          <div className="parallax_content" data-aos="fade-up">
            <h2 className="parallax_heading">A Message of Responsibility</h2>
            <h5 className="parallax_text">
              By gifting 2,500 plants, Sanathan Textiles is sowing the seeds of
              eco-consciousness in 2,500 individuals. This initiative is not
              just about reducing plastic or adding greenery — it's about
              building a community of changemakers who choose to care. One plant
              at a time.
            </h5>
          </div>
        </div>
      </section>

      <section className="esg_main_section">
        <div className="wrapper" data-aos="fade-up">
          <h3 className="main_heading">ENERGY USED FROM RENEWABLE SOURCES</h3>
          <div className="esg_first_main_section">
            <figure className="left_section">
              {width > 767 ? <img src={SecondImg} alt="sanathan img" /> : null}
            </figure>
            <div className="right_section">
              {/* <h3 className="esg_main_section_h3_desktop">
                17% Energy from Renewable Sources
              </h3>
              <h3 className="esg_main_section_h3_mobile">
                17% Energy from Renewable Sources
              </h3> */}
              {width < 767 ? (
                <figure className="left_section">
                  <img src={SecondImg} alt="sanathan img" />
                </figure>
              ) : null}
              <p className="esg_main_section_p_desktop">
                We are an environmentally conscious Company, and we encourage
                the use of renewable resources. Sanathan Textiles have installed
                rooftop solar projects at our Silvassa facility since 2019.
              </p>
              <p className="esg_main_section_p_mobile">
                We are an environmentally conscious Company, and we encourage
                the use of renewable resources. Sanathan Textiles have installed
                rooftop solar projects at our Silvassa facility since 2019.
              </p>
              {/* <figure>
                <img src={ThirdImg} alt="sanathan img" />
              </figure> */}
            </div>
          </div>
          {/* <div className="esg_second_main_section">
                        <div className="esg_second_main_section_heading_and_desc">
                            <h3>Building a better planet <br /> for everyone</h3>
                            <p className="esg_second_main_section_p_desktop">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod <br /> tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At <br /> vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, <br />no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit</p>
                            <p className="esg_second_main_section_p_mobile">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit</p>
                        </div>
                        <div className="esg_second_main_section_slider_wrapper swiper-container">
                            <ul className="swiper-wrapper">
                                <li className="swiper-slide">
                                    <figure>
                                        <img src={SliderImg1} alt="sanathan img"/>
                                    </figure>
                                    <figcaption>Environmental Responsibility</figcaption>
                                </li>
                                <li className="swiper-slide">
                                    <figure>
                                        <img src={SliderImg2} alt="sanathan img"/>
                                    </figure>
                                    <figcaption>Ethical Responsibility</figcaption>
                                </li>
                                <li className="swiper-slide">
                                    <figure>
                                        <img src={SliderImg3} alt="sanathan img"/>
                                    </figure>
                                    <figcaption>Economic Responsibility</figcaption>
                                </li>
                                <li className="swiper-slide">
                                    <figure>
                                        <img src={SliderImg4} alt="sanathan img"/>
                                    </figure>
                                    <figcaption>Philanthropic Responsibility</figcaption>
                                </li>
                            </ul>
                            <div className="navigations">
                                <button className="left_arrow">Previous</button>
                                <button className="right_arrow">Next</button>
                            </div>
                        </div>
                        <div className="csr_section">
                            <div className="left_section">
                                <div className="hollow_title">CSR</div>
                                <h3>Corporate Social Responsibility</h3>
                                <p className="csr_section_desc_desktop">Corporate social responsibility initiatives can, for example, be a powerful <br /> marketing tool, helping a company position itself favorably in the eyes of <br /> consumers, investors, and regulators. CSR initiatives can also improve employee <br /> engagement and satisfaction—key measures that drive retention. Such initiatives <br /> can even attract potential employees who carry strong personal convictions that <br /> match those of the organization. <br /><br />Finally, corporate social responsibility initiatives, by their nature, force business <br /> leaders to examine practices related to how they hire and manage employees, <br /> source products or components, and deliver value to customers. <br /><br />This reflection can often lead to innovative and groundbreaking solutions that <br /> help a company act in a more socially responsible way and increase profits. <br /> Reconceptualizing the manufacturing process so that a company consumes less <br /> energy and produces less waste, for example, allows it to become more <br /> environmentally friendly while reducing its energy and materials costs—value  <br /> that can be reclaimed and shared with both suppliers and customers.</p>
                                <p className="csr_section_desc_mobile">Corporate social responsibility initiatives can, for example, be a powerful marketing tool, helping a company position itself favorably in the eyes of consumers, investors, and regulators. CSR initiatives can also improve employee engagement and satisfaction—key measures that drive retention. Such initiatives can even attract potential employees who carry strong personal convictions that match those of the organization. Finally, corporate social responsibility initiatives, by their nature, force business leaders to examine practices related to how they hire and manage employees, source products or components, and deliver value to customers. This reflection can often lead to innovative and groundbreaking solutions that help a company act in a more socially responsible way and increase profits. Reconceptualizing the manufacturing process so that a company consumes less  energy and produces less waste, for example, allows it to become more environmentally friendly while reducing its energy and materials costs—value  that can be reclaimed and shared with both suppliers and customers.</p>
                            </div>
                            <div className="right_section">
                                <figure className="bg_img">
                                    <img src={CSR1} alt="sanathan img"/>
                                </figure>
                                <figure className="fg_img">
                                    <img src={CSR2} alt="sanathan img"/>
                                </figure>
                            </div>
                        </div>
                    </div> */}
          <div className="esg_third_main_section">
            {width < 767 ? (
              <>
                <h3 className="mobile_heading">BornDyed™ coloured yarns</h3>
              </>
            ) : null}
            <div className="left_section_hollow_box left_section_hollow_box_third">
              <iframe
                src="https://www.youtube.com/embed/OnA4PUhsPfA"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div className="right_section right_section_hollow_box_third">
              {width > 767 ? (
                <>
                  <h3>BornDyed™ coloured yarns</h3>
                </>
              ) : null}

              <p className="esg_third_main_section_p_desktop">
                Our foray into BornDyed™️{" "}
                <Link to="/products/born-dyed" className="new_link">
                  coloured yarns
                </Link>
                , which uses dope dyed technology to produce colour polyester
                yarn, is an solution to producing coloured yarns using dope dyed
                technology. Shortening the supply chain helps in reduced
                production costs and ensures a reduction in the ecological
                footprint of the final products. The products under this
                category are made by using dope dyed technology wherein the
                colour pigment is added to the yarn during the polymerisation
                stage. The fabric manufactured from this yarn is mainly utilized
                in the making of outer-wear, shirts, trousers, suiting,
                rainwear, ties, school belts, bags, upholstery etc.
              </p>
              <p className="esg_third_main_section_p_mobile">
                Our foray into BornDyed™️{" "}
                <Link to="/products/born-dyed" className="new_link">
                  coloured yarns
                </Link>
                , which uses dope dyed technology to produce colour polyester
                yarn, is an solution to producing coloured yarns using dope dyed
                technology. Shortening the supply chain helps in reduced
                production costs and ensures a reduction in the ecological
                footprint of the final products. The products under this
                category are made by using dope dyed technology wherein the
                colour pigment is added to the yarn during the polymerisation
                stage. The fabric manufactured from this yarn is mainly utilized
                in the making of outer-wear, shirts, trousers, suiting,
                rainwear, ties, school belts, bags, upholstery etc.
              </p>
            </div>
          </div>
          <div className="esg_fourth_main_section esg_fourth_main_section_desktop">
            <div className="left_section">
              <h3>Sanathan Reviro</h3>
              <p className="esg_fourth_main_section_p_desktop esg_fourth_desk">
                We manufacture products from recycled materials which are sold
                under the brand ‘Sanathan Reviro’...
              </p>
              <p className="esg_fourth_main_section_p_mobile">
                We manufacture products from recycled materials which are sold
                under the brand ‘Sanathan Reviro’...
              </p>
            </div>
            <div className="right_section_hollow_box">
              <iframe
                src="https://www.youtube.com/embed/-c-GVI-foRs"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div className="esg_fourth_main_section esg_fourth_main_section_mobile">
            <h3>Sanathan Reviro</h3>
            <div className="right_section_hollow_box right_section_hollow_box_sanathan_reviro">
              <iframe
                src="https://www.youtube.com/embed/-c-GVI-foRs"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div className="left_section">
              <p className="esg_fourth_main_section_p_desktop">
                We manufacture products from recycled materials which are sold
                under the brand ‘Sanathan Reviro’...
              </p>
              <p className="esg_fourth_main_section_p_mobile">
                We manufacture products from recycled materials which are sold
                under the brand ‘Sanathan Reviro’...
              </p>
            </div>
          </div>
          <div className="esg_fifth_main_section">
            {width < 767 ? (
              <>
                <div className="hollow_title">CSR</div>
                {/* <h3>Corporate Social Responsibility</h3> */}
                {/* <h4 className="mobile_heading">Child Development Program</h4> */}
              </>
            ) : null}
            <div className="left_section_hollow_box">
              <iframe
                // width="815"
                // height="671"
                src="https://www.youtube.com/embed/ZSsNEXs86Pc"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            <div className="right_section">
              {width > 767 ? (
                <>
                  <div className="hollow_title">CSR</div>
                  {/* <h3>Corporate Social Responsibility</h3>
                  <h4>Child Development Program</h4> */}
                </>
              ) : null}
              <p className="esg_fifth_main_section_p_desktop">
                We have constituted a corporate and social responsibility
                committee and have adopted and implemented a CSR Policy pursuant
                to which we carry out CSR activities. In terms of our CSR policy
                our CSR expenditure may be towards, amongst others, eradicating
                hunger, poverty and malnutrition, promoting health care,
                promoting education, promoting gender equality, empowering
                women, ensuring environmental sustainability, ecological balance
                etc.
              </p>
              <p className="esg_fifth_main_section_p_mobile">
                We have constituted a corporate and social responsibility
                committee and have adopted and implemented a CSR Policy pursuant
                to which we carry out CSR activities. In terms of our CSR policy
                our CSR expenditure may be towards, amongst others, eradicating
                hunger, poverty and malnutrition, promoting health care,
                promoting education, promoting gender equality, empowering
                women, ensuring environmental sustainability, ecological balance
                etc.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="new_renuable_energy new_renuable_energy_desktop">
        <div className="left_section">
          <h3>
            Sanathan Textiles in Association <br /> with Dattani Foundation.
          </h3>
          <p className="new_renuable_energy_p_desktop">
            On behalf of all our colleagues, clients and business associates, we{" "}
            <br /> have extended our support in our small way towards the <br />{" "}
            following causes: <br />
            <br />
          </p>
          <ul className="points_wrapper">
            <li>
              <p>
                Donation to Administrators COVID relief fund of Dadra and Nagar
                Haveli and Daman and Diu
              </p>
            </li>
            <li>
              <p>
                Supported the Federation of Industries Association, Silvassa to
                fight the Covid situation in DNH
              </p>
            </li>
            <li>
              <p>
                Donated & Assisted in the Installation of ventilators at Shri
                Vinoba Bhave Civil Hospital, Silvassa
              </p>
            </li>
            <li>
              <p>
                Supported Quarancharity in its mission to help both people and
                animals suffering during the Covid-19 lockdown
              </p>
            </li>
            <li>
              <p>Collaborated with Akshay Patra Foundation for food donation</p>
            </li>
            <li>
              <p>
                Participated with Healthy Aging India for their meal
                distribution
              </p>
            </li>
          </ul>
        </div>
        <div className="right_section">
          <img src={FifthImg} alt="sanathan img" />
        </div>
      </section>
      <section className="new_renuable_energy new_renuable_energy_mobile">
        <div className="right_section">
          <img src={FifthImg} alt="sanathan img" />
        </div>
        <div className="left_section">
          <h3>Sanathan Textiles in Association with Dattani Foundation.</h3>
          <p className="new_renuable_energy_p_mobile">
            On behalf of all our colleagues, clients and business associates, we
            have extended our support in our small way towards the following
            causes: <br />
            <br />
          </p>
          <ul className="points_wrapper">
            <li>
              <p>
                Donation to Administrators COVID relief fund of Dadra and Nagar
                Haveli and Daman and Diu
              </p>
            </li>
            <li>
              <p>
                Supported the Federation of Industries Association, Silvassa to
                fight the Covid situation in DNH
              </p>
            </li>
            <li>
              <p>
                Donated & Assisted in the Installation of ventilators at Shri
                Vinoba Bhave Civil Hospital, Silvassa
              </p>
            </li>
            <li>
              <p>
                Supported Quarancharity in its mission to help both people and
                animals suffering during the Covid-19 lockdown
              </p>
            </li>
            <li>
              <p>Collaborated with Akshay Patra Foundation for food donation</p>
            </li>
            <li>
              <p>
                Participated with Healthy Aging India for their meal
                distribution
              </p>
            </li>
          </ul>
        </div>
      </section>
      {/* <section className="renuable_energy renuable_energy_desktop">
                <div className="wrapper" data-aos="fade-up">
                    <div className="hollow_title">Renuable <br /> Energy</div>
                    <div className="content">
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor <br /> invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam <br /> et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est <br /> Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor <br /> invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam <br /> et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est <br /> Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                    </div>
                </div>
                <figure>
                    <img src={FourthImg} alt="sanathan img"/>
                </figure>
            </section>
            <section className="renuable_energy renuable_energy_mobile">
                <div className="wrapper" data-aos="fade-up">
                    <div className="hollow_title">Renuable <br /> Energy</div>
                    <figure>
                        <img src={FourthImg} alt="sanathan img"/>
                    </figure>
                    <div className="content content_desktop">
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor <br /> invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam <br /> et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est <br /> Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor <br /> invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam <br /> et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est <br /> Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                    </div>
                    <div className="content content_mobile">
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed</p>
                    </div>
                </div>
            </section> */}
    </>
  );
};

export default ESG;
